import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * `approvals` em português do Brasil. Declarado, nunca inferido, então uma lacuna quebra o `tsc`.
 *
 * `aprovação` é o termo ratificado (ADR-0018), e a fala é direta: quem está prestes a
 * autorizar uma ação precisa ler o que vai acontecer, não uma versão elegante disso. Por
 * isso `irreversible` é "não dá para desfazer" e não *irreversível*, do mesmo jeito que o
 * inglês escolheu a fala comum em vez da palavra técnica.
 *
 * As seis classes de risco concordam com `ação`, que é feminino — "privilegiada",
 * "financeira", "destrutiva" —, e o fallback "sem classificação" evita o gênero por
 * completo.
 */
export const approvals: Messages['approvals'] = {
  needsApproval: (displayName) => `${displayName} precisa da sua aprovação`,

  risk: {
    read: 'leitura',
    reversible_write: 'escrita reversível',
    external_communication: 'comunicação externa',
    privileged: 'privilegiada',
    financial: 'financeira',
    destructive: 'destrutiva'
  },
  riskUnknown: 'sem classificação',

  irreversible: 'não dá para desfazer',

  dataReaching: 'Os dados vão chegar a:',

  payloadTitle: 'Exatamente o que será executado',
  editLabel: 'Editar os argumentos propostos',
  invalidJson: (detail) => `JSON inválido: ${detail}`,

  notePlaceholder: 'Adicione uma nota para o registro (opcional)',
  noteLabel: 'Nota da decisão',

  approve: 'Aprovar',
  editFirst: 'Editar antes',
  reject: 'Recusar',
  approveEdited: 'Aprovar com edição',
  cancelEdit: 'Cancelar edição',

  /**
   * Dois-pontos em vez de verbo. `formatUntil` devolve "em 3 h" quando falta tempo e a
   * palavra "expirado" quando já passou — "expira expirado" não é frase (LOC-022).
   */
  expires: (when) => `prazo: ${when}`
}
